import { HttpClient } from '@angular/common/http';
import { Injectable, OnInit } from '@angular/core';
import { environment } from '../../environments/environment';
import { CameraModel } from '../models/camera.model';

/**
 * This service manages Cameras in the camera application database
 */
@Injectable({
  providedIn: 'root',
})
export class CameraService {
  constructor(private http: HttpClient) { }

  /**
   * Update an existing camera
   * @param  {CameraModel} camera - Camera model to update
   * @returns Promise
   */
  async saveCamera(camera: CameraModel): Promise<CameraModel> {
    return new Promise((resolve, reject) => {
      this.http
        .put<CameraModel>(`${environment.managementApi}/cameras/update`, camera)
        .subscribe({
          next: (rtnval) => {
            resolve(rtnval);
          },
          error: (err) => {
            reject(err);
          }
        });
    });
  }

  /**
   * Delete a camera by ID
   * @param  {number} cameraId - Camera ID
   * @returns Promise
   */
  async deleteCamera(cameraId: number): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.http
        .delete(`${environment.managementApi}/cameras/${cameraId}/delete`)
        .subscribe({
          next: () => {
            resolve();
          },
          error: (err) => {
            reject(err);
          }
        });
    });
  }
}
